var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFloatCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25070_67827)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#E3E8FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 16.2,
    width: 49.6,
    height: 49.6,
    rx: 24.8,
    stroke: "#E2E2E8",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1572 25.3555C42.5749 25.3555 42.9131 25.6937 42.9131 26.1113C42.9133 34.0029 49.3116 40.4003 57.2031 40.4004C57.2552 40.4004 57.3063 40.405 57.3555 40.415C57.5524 40.4553 57.7214 40.5726 57.8301 40.7334C57.9117 40.8542 57.959 41.0005 57.959 41.1572C57.9589 41.2615 57.9377 41.3608 57.8994 41.4512C57.8228 41.632 57.678 41.7771 57.4971 41.8535C57.452 41.8725 57.4045 41.8874 57.3555 41.8975C57.3063 41.9075 57.2552 41.9131 57.2031 41.9131C49.3114 41.9132 42.9131 48.3104 42.9131 56.2021C42.9129 56.6197 42.5748 56.958 42.1572 56.958L42.1553 56.957L42.1533 56.958C41.7359 56.9579 41.3966 56.6196 41.3965 56.2021C41.3965 48.322 35.0183 41.9309 27.1426 41.9121C27.1309 41.9121 27.1191 41.9131 27.1074 41.9131C26.6901 41.9129 26.352 41.5745 26.3516 41.1572C26.3516 40.7396 26.6899 40.4005 27.1074 40.4004C34.9991 40.4004 41.3962 34.0029 41.3965 26.1113C41.3965 25.6937 41.7358 25.3556 42.1533 25.3555H42.1572ZM42.1553 30.9434C40.603 35.7809 36.7838 39.6017 31.9473 41.1562C36.7834 42.7106 40.6027 46.5312 42.1553 51.3682C43.7077 46.5316 47.5267 42.7109 52.3623 41.1562C47.5263 39.6015 43.7074 35.7805 42.1553 30.9434Z",
    fill: "#636980"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 44,
    width: 13.25,
    height: 13.25,
    rx: 6.625,
    fill: "#08C108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7777 54V48.8933H53.1455V54H51.7777ZM52.4667 48.1942C52.2235 48.1942 52.0208 48.1232 51.8587 47.9814C51.7033 47.8328 51.6257 47.647 51.6257 47.4241C51.6257 47.2012 51.7033 47.0188 51.8587 46.877C52.0208 46.7283 52.2235 46.654 52.4667 46.654C52.7166 46.654 52.9192 46.7283 53.0746 46.877C53.2367 47.0188 53.3178 47.2012 53.3178 47.4241C53.3178 47.647 53.2367 47.8328 53.0746 47.9814C52.9192 48.1232 52.7166 48.1942 52.4667 48.1942Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25070_67827",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25070_67827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25070_67827",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFloatCycle);
export default __webpack_public_path__ + "static/media/userFloatCycle.4836786ed8c99ff7d72a752fd6acba41.svg";
export { ForwardRef as ReactComponent };